import React from "react";
import { Link } from "react-router-dom";

function Header() {
  return (
    <header className="px-4 py-3 border-b bg-white">
      <div className="flex items-center justify-between flex-wrap">
        {/* Left: Logo + Brand + Home Button */}
        <div className="flex items-center space-x-4">
          <img
            src="/favicon.png"
            alt="PScribes speech to text logo"
            className="h-8 w-8 sm:h-10 sm:w-10"
          />
          <Link to="/" className="text-xl sm:text-3xl font-extrabold tracking-tight bg-gradient-to-r from-purple-600 via-blue-500 to-purple-600 text-transparent bg-clip-text drop-shadow-sm">
            PScribes
          </Link>
        </div>
		
		{/* TTS */}
        <div className="flex items-center space-x-4">
          <Link
            to="/ttspage"
            className="bg-white text-blue-600 rounded-md px-4 py-2 text-lg font-bold hover:bg-blue-50"
          >
            Text to Speech (TTS)
          </Link>
        </div>
		
		{/* STT */}
        <div className="flex items-center space-x-4">
          <Link
            to="/"
            className="bg-white text-blue-600 rounded-md px-4 py-2 text-lg font-bold hover:bg-blue-50"
          >
            Speech to Text (STT)
          </Link>
        </div>

        {/* Right: Sign In button */}
        <div className="mt-2 sm:mt-0">
          <Link
            to="/signin"
            className="bg-white text-blue-600 border border-blue-600 rounded-md px-4 py-2 text-sm font-bold hover:bg-blue-50"
          >
            Sign in
          </Link>
        </div>
      </div>
    </header>
  );
}

export default Header;
